import { ApiCalendarEvent } from "../models/calendarEvent";
import { RestService } from "./restService";

export class EventService extends RestService<ApiCalendarEvent> {
    public constructor(baseUrl: string, baseRoute: string) {
        super(baseUrl, baseRoute);
    }
}
